import React from 'react'
import StaticPages from 'src/components/static_pages/static_pages'
import { CLASS_PREFIX } from 'src/constants'
import { textResources } from 'src/lang/de'
import './initial_auth_footer.scss'

type Props = {
  mode: 'login' | 'register'
  setMode: (mode: 'login' | 'register') => void
  closeModal: () => void
  closeable?: boolean
}

const cls = `${CLASS_PREFIX}initial_auth_footer`

export const InitialAuthFooter: React.FC<Props> = ({ mode, setMode, closeModal, closeable = true }) => {
  return (
    <div className={cls}>
      { mode === 'login'
        ? (
          <p>
            {textResources.authentication.noAccountYet} <button className={cls + '__swap_mode'} onClick={() => setMode('register')}>{textResources.shared.register}</button>
          </p>
        )
        : (
          <p>
            {textResources.authentication.alreadyHaveAccount} <button className={cls + '__swap_mode'} onClick={() => setMode('login')}>{textResources.shared.login}</button>
          </p>
        )}
      <StaticPages />
      {closeable && <button className={cls + '__close'} onClick={closeModal}>{textResources.shared.close}</button>}
    </div>
  )
}
